import { useMemo } from 'react';
import { dayjs, metersToMiles } from '../lib/utils';
import type { CompletedWorkout } from './useProfile';

const isRunningWorkout = (workout: Pick<CompletedWorkout, 'type'>) => {
  const type = workout.type?.toLowerCase() || '';
  return type === 'running' || type.includes('run');
};

export const useMonthlyRunningTotals = (
  workouts: CompletedWorkout[] | undefined,
) => {
  return useMemo(() => {
    return (workouts || []).reduce<Record<string, number>>(
      (totals, workout) => {
        if (!isRunningWorkout(workout)) {
          return totals;
        }

        const key = dayjs(workout.completedAt).format('MMMM YYYY');
        totals[key] = (totals[key] || 0) + metersToMiles(workout.distance || 0);
        return totals;
      },
      {},
    );
  }, [workouts]);
};
